<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from "axios";
import Swal from "sweetalert2";
// import { defineAsyncComponent, ref } from "vue";
// import moment from "moment";



export default {
  page: {
    title: "Detail Evaluasi Pasca Pelatihan",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Detail Evaluasi Pasca Pelatihan",
      items: [
        {
          text: "Evaluasi",
          href: "/evaluasi",
        },
        {
          text: "Detail Evaluasi Pasca Pelatihan",
          active: true,
        },
      ],

      id: this.$route.params.id,
      nomor_surat: null,
      kode: null,
      judul: null,
      dasar_pelaksanaan: null,
      strategi: null,
      strategi_id: null,
      durasi_he: null,
      durasi_jp: null,
      tanggal_mulai: null,
      tanggal_selesai: null,
      learning_type: null,
      angkatan: null,

      optionRowA: 2,
      optionRowB: 1,
      optionRowC: 4,
      optionRowD: 2,
      optionRowE: 3,
      optionRowF: 1,
      optionRowG: 2,
      optionRowH: 2,
      optionRowI: 2,
      optionRowJ: 3,
      optionRowK: 1,
      optionRowL: 4,
      optionRowM: 4,
      optionRowN: 1,
      optionRowO: 2,
      optionRowP: 1,
      optionRowQ: 3,
      optionRowR: 2,
      optionRowS: 1,
      optionRowT: 4,

      myTextarea: 'Beberapa faktor lain seperti seberapa sering dalam berdiskusi, dan seberapa besar pemahaman dalam pelaksanaan latihan'
    };
  },
  mounted() {
    let self = this;
    Swal.fire({
      title: '<i class="fas fa-spinner fa-spin"></i>',
      text: "Loading...",
      showConfirmButton: false,
      allowOutsideClick: false,
    });

    // get data pembelajaran
    var config = {
      method: "get",
      url:
        process.env.VUE_APP_BACKEND_URL_VERSION + "transactions/pembelajaran",
      params: {
        id: self.id,
      },
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.access_token,
      },
    };
    axios(config)
      .then(function (response) {
        var response_data = response.data;
        var response_data_fix = response_data.data;
        if (response_data.meta.code == 200) {
          var data_edit = response_data_fix.data_pembelajaran;
          self.nomor_surat = data_edit.pbl_nomor_surat;
          self.kode = data_edit.pbl_kode;
          self.judul = data_edit.pbl_dasar_pelaksanaan;
          self.dasar_pelaksanaan = data_edit.pbl_judul;
          self.strategi = data_edit.pbl_strategi;
          self.strategi_id = data_edit.pbl_strategi_id;
          self.durasi_he = data_edit.pbl_durasi_he;
          self.durasi_jp = data_edit.pbl_durasi_jp;
          self.tanggal_mulai = data_edit.pbl_tgl_mulai;
          self.tanggal_selesai = data_edit.pbl_tgl_selesai;
          self.learning_type = data_edit.pbl_lt_name;
          self.angkatan = data_edit.pbl_angkatan;

          self.pratikum = data_edit.pbl_pratikum;

          Swal.close();
        } else {
          Swal.close();
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response_data_fix.data.message,
          });
        }
      })
      .catch(function (error) {
        console.log(error);
        Swal.close();
      });
  },
  methods: {
  },
};
</script>
<style>
/* my Style */
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-12 text-end mb-3">
            <router-link :to="`/evaluasi`" class="btn btn-danger"><i class="fa fa-arrow-left"></i> <b>Kembali</b></router-link>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <b-card header-class="bg-transparent border-primary" class="border border-primary">
                  <template v-slot:header>
                    <h5 class="my-0 text-primary">
                      <i class="mdi mdi-calendar-edit me-3"></i> Formulir
                      Perencanaan Pembelajaran
                    </h5>
                  </template>
                  <div class="card-body p-0">
                    <div class="row">
                      <div class="col-3">
                        <div class="row">
                          <div class="col-12">
                            <h5 class="font-size-12">
                              <span class="text-dark">Nomor Surat</span>
                            </h5>
                            <p class="text-muted mb-0 font-size-11">{{ nomor_surat }}</p>
                            <hr style="margin:0 !important;">
                          </div>
                          <div class="col-12">
                            <h5 class="font-size-12">
                              <span class="text-dark">Kode Pembelajaran</span>
                            </h5>
                            <p class="text-muted mb-0 font-size-11">{{ kode }}</p>
                            <hr style="margin:0 !important;">
                          </div>
                          <div class="col-12">
                            <h5 class="font-size-12">
                              <span class="text-dark">Dasar Pelaksanaan</span>
                            </h5>
                            <p class="text-muted mb-0 font-size-11">
                              {{ dasar_pelaksanaan }}
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="row">
                          <div class="col-12">
                            <h5 class="font-size-12">
                              <span class="text-dark">Judul Pembelajaran</span>
                            </h5>
                            <p class="text-muted mb-0 font-size-11">{{ judul }}</p>
                            <hr style="margin:0 !important;">
                          </div>
                          <div class="col-12">
                            <h5 class="font-size-12">
                              <span class="text-dark">Strategi</span>
                            </h5>
                            <p class="text-muted mb-0 font-size-11">{{ strategi }}</p>
                            <hr style="margin:0 !important;">
                          </div>
                          <div class="col-12">
                            <h5 class="font-size-12">
                              <span class="text-dark">Tipe Pembelajaran</span>
                            </h5>
                            <p class="text-muted mb-0 font-size-11">{{ learning_type }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="row">
                          <div class="col-12">
                            <h5 class="font-size-12">
                              <span class="text-dark">PIC</span>
                            </h5>
                            <p class="text-muted mb-0 font-size-11">{{ pic }}</p>
                            <hr style="margin:0 !important;">
                          </div>
                          <div class="col-12">
                            <h5 class="font-size-12">
                              <span class="text-dark">Angkatan</span>
                            </h5>
                            <p class="text-muted mb-0 font-size-11">{{ angkatan }}</p>
                            <hr style="margin:0 !important;">
                          </div>
                          <div class="col-12">
                            <h5 class="font-size-12">
                              <span class="text-dark">Pratikum</span>
                            </h5>
                            <p class="text-muted mb-0 font-size-11">{{ pratikum }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="col-12">
                          <div class="row">
                            <div class="col-12">
                              <h5 class="font-size-12 mb-1">
                                <span class="text-dark">Durasi Hari Efektif (HE)</span>
                              </h5>
                              <p class="text-muted mb-0 font-size-11">{{ durasi_he }}</p>
                              <hr style="margin:0 !important;">
                            </div>
                            <div class="col-12">
                              <h5 class="font-size-12 mb-1">
                                <span class="text-dark">Durasi Jam Pembelajaran (JP)</span>
                              </h5>
                              <p class="text-muted mb-0 font-size-11">{{ durasi_jp }}</p>
                              <hr style="margin:0 !important;">
                            </div>
                          </div>
                        </div>

                        <div class="col-12">
                          <div class="row">
                            <div class="col-12">
                              <h5 class="font-size-12 mb-1">
                                <span class="text-dark">Tanggal Mulai</span>
                              </h5>
                              <p class="text-muted mb-0 font-size-11">
                                {{ tanggal_mulai }}
                              </p>
                              <hr style="margin:0 !important;">
                            </div>
                            <div class="col-12">
                              <h5 class="font-size-12 font-size-12">
                                <span class="text-dark">Tanggal Selesai</span>
                              </h5>
                              <p class="text-muted mb-0 font-size-11">
                                {{ tanggal_selesai }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-card>
              </div>
              <div class="col-12">
                <b-card header-class="bg-transparent border-primary" class="border border-primary">
                  <div class="card-body p-0">
                    <b-tabs pills justified content-class="p-3 text-muted">
                      <b-tab active class="border-0">
                        <template v-slot:title>
                          <!-- <h5 class="my-0 text-primary">
                            <i class="mdi mdi-calendar-edit me-3"></i> Perubahan Sikap Perilaku
                          </h5> -->
                          <span class="d-inline-block d-sm-none">
                            <i class="mdi mdi-calendar-edit me-3"></i>
                          </span>
                          <span class="d-none d-sm-inline-block">Perubahan Sikap Perilaku</span>
                        </template>
                        <div class="row mt-3 mb-2">
                          <div class="col-6">
                            <div class="card-title">
                              Form Perubahan Sikap Perilaku
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="d-flex justify-content-end">
                              <!-- button Menu -->
                            </div>
                          </div>
                        </div>

                        <!-- Content Tabs -->
                        <div class="row">
                          <div class="col-12">
                            <p class="mb-3 font-size-14">
                              Bagaimana penilaian Anda terhadap sikap perilaku staf Anda di tempat kerja setelah mengikuti Pelatihan Kepemimpinan ?
                            </p>

                            <form>
                              <table class="table table-stripped table-condensed">
                                <thead class="greyTheme">
                                  <tr>
                                    <th class="text-center align-middle">No</th>
                                    <th class="text-center align-middle">Pernyataan</th>
                                    <th class="text-center align-middle" colspan="4">Jawaban</th>
                                  </tr>
                                </thead>
                                <tbody class="greyTheme">
                                  <tr class="headerRow">
                                    <td colspan="30"><b>Kepemimpinan Pancasila dan Bela Negara</b></td>
                                  </tr>
                                  <tr>
                                    <td class="text-center">1</td>
                                    <td>
                                      Mampu menunjukkan sikap perilaku bela negara yakni taat pada hukum dan aturan
                                      negara dalam menjalankan tugas jabatan
                                    </td>
                                    <td>
                                      <label for="optionRowA1" class="radioGroup">
                                        <input type="radio" id="optionRowA1" value="1" name="optionRowA" v-model="optionRowA" disabled>
                                        <span>1</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowA2" class="radioGroup">
                                        <input type="radio" id="optionRowA2" value="2" name="optionRowA" v-model="optionRowA" disabled>
                                        <span>2</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowA3" class="radioGroup">
                                        <input type="radio" id="optionRowA3" value="3" name="optionRowA" v-model="optionRowA" disabled>
                                        <span>3</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowA4" class="radioGroup">
                                        <input type="radio" id="optionRowA4" value="4" name="optionRowA" v-model="optionRowA" disabled>
                                        <span>4</span>
                                      </label>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="text-center">2</td>
                                    <td>
                                      Mampu menginventarisasi solusi kreatif dan kekinian dalam kerangka kerja nilai-nilai
                                      Pancasila dan bela Negara dalam mengantisipasi hambatan pemberantasan korupsi dalam pelayanan
                                    </td>
                                    <td>
                                      <label for="optionRowB1" class="radioGroup">
                                        <input type="radio" id="optionRowB1" value="1" name="optionRowB" v-model="optionRowB" disabled>
                                        <span>1</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowB2" class="radioGroup">
                                        <input type="radio" id="optionRowB2" value="2" name="optionRowB" v-model="optionRowB" disabled>
                                        <span>2</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowB3" class="radioGroup">
                                        <input type="radio" id="optionRowB3" value="3" name="optionRowB" v-model="optionRowB" disabled>
                                        <span>3</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowB4" class="radioGroup">
                                        <input type="radio" id="optionRowB4" value="4" name="optionRowB" v-model="optionRowB" disabled>
                                        <span>4</span>
                                      </label>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="text-center">3</td>
                                    <td>
                                      Dapat memberikan teladan bagi bawahannya dalam melakukan praktik yang mencerminkan
                                      nilai-nilai wawasan kebangsaan, kerangka berpikir nilai-nilai Pancasila dan bela negara
                                      sebagai fondasi pelayanan
                                    </td>
                                    <td>
                                      <label for="optionRowC1" class="radioGroup">
                                        <input type="radio" id="optionRowC1" value="1" name="optionRowC" v-model="optionRowC" disabled>
                                        <span>1</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowC2" class="radioGroup">
                                        <input type="radio" id="optionRowC2" value="2" name="optionRowC" v-model="optionRowC" disabled>
                                        <span>2</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowC3" class="radioGroup">
                                        <input type="radio" id="optionRowC3" value="3" name="optionRowC" v-model="optionRowC" disabled>
                                        <span>3</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowC4" class="radioGroup">
                                        <input type="radio" id="optionRowC4" value="4" name="optionRowC" v-model="optionRowC" disabled>
                                        <span>4</span>
                                      </label>
                                    </td>
                                  </tr>
                                  <tr class="headerRow">
                                    <td colspan="30">
                                      <b>Kepemimpinan Melayani</b>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="text-center">4</td>
                                    <td>
                                      Memahami dan memenuhi kebutuhan masyarakat
                                    </td>
                                    <td>
                                      <label for="optionRowD1" class="radioGroup">
                                        <input type="radio" id="optionRowD1" value="1" name="optionRowD" v-model="optionRowD" disabled>
                                        <span>1</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowD2" class="radioGroup">
                                        <input type="radio" id="optionRowD2" value="2" name="optionRowD" v-model="optionRowD" disabled>
                                        <span>2</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowD3" class="radioGroup">
                                        <input type="radio" id="optionRowD3" value="3" name="optionRowD" v-model="optionRowD" disabled>
                                        <span>3</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowD4" class="radioGroup">
                                        <input type="radio" id="optionRowD4" value="4" name="optionRowD" v-model="optionRowD" disabled>
                                        <span>4</span>
                                      </label>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="text-center">5</td>
                                    <td>
                                      Ramah, cekatan, solutif dan dapat diandalkan
                                    </td>
                                    <td>
                                      <label for="optionRowE1" class="radioGroup">
                                        <input type="radio" id="optionRowE1" value="1" name="optionRowE" v-model="optionRowE" disabled>
                                        <span>1</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowE2" class="radioGroup">
                                        <input type="radio" id="optionRowE2" value="2" name="optionRowE" v-model="optionRowE" disabled>
                                        <span>2</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowE3" class="radioGroup">
                                        <input type="radio" id="optionRowE3" value="3" name="optionRowE" v-model="optionRowE" disabled>
                                        <span>3</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowE4" class="radioGroup">
                                        <input type="radio" id="optionRowE4" value="4" name="optionRowE" v-model="optionRowE" disabled>
                                        <span>4</span>
                                      </label>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="text-center">6</td>
                                    <td>
                                      Dapat mendiagnosa permasalahan yang ada
                                    </td>
                                    <td>
                                      <label for="optionRowF1" class="radioGroup">
                                        <input type="radio" id="optionRowF1" value="1" name="optionRowF" v-model="optionRowF" disabled>
                                        <span>1</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowF2" class="radioGroup">
                                        <input type="radio" id="optionRowF2" value="2" name="optionRowF" v-model="optionRowF" disabled>
                                        <span>2</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowF3" class="radioGroup">
                                        <input type="radio" id="optionRowF3" value="3" name="optionRowF" v-model="optionRowF" disabled>
                                        <span>3</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowF4" class="radioGroup">
                                        <input type="radio" id="optionRowF4" value="4" name="optionRowF" v-model="optionRowF" disabled>
                                        <span>4</span>
                                      </label>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="text-center">7</td>
                                    <td>
                                      Melaksanakan tugas dengan jujur, bertanggung jawab, cermat, disiplin, dan berintegritas tinggi
                                    </td>
                                    <td>
                                      <label for="optionRowG1" class="radioGroup">
                                        <input type="radio" id="optionRowG1" value="1" name="optionRowG" v-model="optionRowG" disabled>
                                        <span>1</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowG2" class="radioGroup">
                                        <input type="radio" id="optionRowG2" value="2" name="optionRowG" v-model="optionRowG" disabled>
                                        <span>2</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowG3" class="radioGroup">
                                        <input type="radio" id="optionRowG3" value="3" name="optionRowG" v-model="optionRowG" disabled>
                                        <span>3</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowG4" class="radioGroup">
                                        <input type="radio" id="optionRowG4" value="4" name="optionRowG" v-model="optionRowG" disabled>
                                        <span>4</span>
                                      </label>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="text-center">8</td>
                                    <td>
                                      Dapat berpikir kreatif
                                    </td>
                                    <td>
                                      <label for="optionRowH1" class="radioGroup">
                                        <input type="radio" id="optionRowH1" value="1" name="optionRowH" v-model="optionRowH" disabled>
                                        <span>1</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowH2" class="radioGroup">
                                        <input type="radio" id="optionRowH2" value="2" name="optionRowH" v-model="optionRowH" disabled>
                                        <span>2</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowH3" class="radioGroup">
                                        <input type="radio" id="optionRowH3" value="3" name="optionRowH" v-model="optionRowH" disabled>
                                        <span>3</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowH4" class="radioGroup">
                                        <input type="radio" id="optionRowH4" value="4" name="optionRowH" v-model="optionRowH" disabled>
                                        <span>4</span>
                                      </label>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="text-center">9</td>
                                    <td>
                                      Tidak menyalahgunakan kewenangan jabatan
                                    </td>
                                    <td>
                                      <label for="optionRowI1" class="radioGroup">
                                        <input type="radio" id="optionRowI1" value="1" name="optionRowI" v-model="optionRowI" disabled>
                                        <span>1</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowI2" class="radioGroup">
                                        <input type="radio" id="optionRowI2" value="2" name="optionRowI" v-model="optionRowI" disabled>
                                        <span>2</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowI3" class="radioGroup">
                                        <input type="radio" id="optionRowI3" value="3" name="optionRowI" v-model="optionRowI" disabled>
                                        <span>3</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowI4" class="radioGroup">
                                        <input type="radio" id="optionRowI4" value="4" name="optionRowI" v-model="optionRowI" disabled>
                                        <span>4</span>
                                      </label>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="text-center">10</td>
                                    <td>
                                      Meningkatkan kompetensi diri untuk menjawab tantangan yang selalu berubah
                                    </td>
                                    <td>
                                      <label for="optionRowJ1" class="radioGroup">
                                        <input type="radio" id="optionRowJ1" value="1" name="optionRowJ" v-model="optionRowJ" disabled>
                                        <span>1</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowJ2" class="radioGroup">
                                        <input type="radio" id="optionRowJ2" value="2" name="optionRowJ" v-model="optionRowJ" disabled>
                                        <span>2</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowJ3" class="radioGroup">
                                        <input type="radio" id="optionRowJ3" value="3" name="optionRowJ" v-model="optionRowJ" disabled>
                                        <span>3</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowJ4" class="radioGroup">
                                        <input type="radio" id="optionRowJ4" value="4" name="optionRowJ" v-model="optionRowJ" disabled>
                                        <span>4</span>
                                      </label>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </form>
                          </div>
                        </div>
                      </b-tab>

                      <b-tab>
                        <template v-slot:title>
                          <span class="d-inline-block d-sm-none">
                            <i class="mdi mdi-calendar-edit me-3"></i>
                          </span>
                          <span class="d-none d-sm-inline-block">Form Data Pelatihan</span>
                        </template>
                        <div class="row mt-3 mb-2">
                          <div class="col-6">
                            <div class="card-title">
                              Form Data Pelatihan
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="d-flex justify-content-end">
                              <!-- button Menu -->
                            </div>
                          </div>
                        </div>

                        <!-- Content Tabs -->
                        <div class="row">
                          <div class="col-12">
                            <p class="mb-3 font-size-14">
                              Bagaimana penilaian Anda terhadap dampak dari pelatihan Kepemimpinan Pengawas bagi staf Anda
                              dalam melaksanakan tugas dan jabatannya ?
                            </p>

                            <form>
                              <table class="table table-stripped table-condensed">
                                <thead class="greyTheme">
                                  <tr>
                                    <th class="text-center align-middle" style="width:5%;">No</th>
                                    <th class="text-center align-middle">Pernyataan</th>
                                    <th class="text-center align-middle" colspan="4">Jawaban</th>
                                  </tr>
                                </thead>
                                <tbody class="greyTheme">
                                  <tr class="headerRow">
                                    <td colspan="30"><b>Produktivitas</b></td>
                                  </tr>
                                  <tr>
                                    <td class="text-center">1</td>
                                    <td>
                                      Terdapat peningkatan produktivitas individu setelah mengikuti pelatihan
                                    </td>
                                    <td>
                                      <label for="optionRowK1" class="radioGroup">
                                        <input type="radio" id="optionRowK1" value="1" name="optionRowK" v-model="optionRowK" disabled>
                                        <span>1</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowK2" class="radioGroup">
                                        <input type="radio" id="optionRowK2" value="2" name="optionRowK" v-model="optionRowK" disabled>
                                        <span>2</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowK3" class="radioGroup">
                                        <input type="radio" id="optionRowK3" value="3" name="optionRowK" v-model="optionRowK" disabled>
                                        <span>3</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowK4" class="radioGroup">
                                        <input type="radio" id="optionRowK4" value="4" name="optionRowK" v-model="optionRowK" disabled>
                                        <span>4</span>
                                      </label>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="text-center">2</td>
                                    <td>
                                      Dapat berkontibusi lebih dalam peningkatan pelayanan kepada stakeholder
                                    </td>
                                    <td>
                                      <label for="optionRowL1" class="radioGroup">
                                        <input type="radio" id="optionRowL1" value="1" name="optionRowL" v-model="optionRowL" disabled>
                                        <span>1</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowL2" class="radioGroup">
                                        <input type="radio" id="optionRowL2" value="2" name="optionRowL" v-model="optionRowL" disabled>
                                        <span>2</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowL3" class="radioGroup">
                                        <input type="radio" id="optionRowL3" value="3" name="optionRowL" v-model="optionRowL" disabled>
                                        <span>3</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowL4" class="radioGroup">
                                        <input type="radio" id="optionRowL4" value="4" name="optionRowL" v-model="optionRowL" disabled>
                                        <span>4</span>
                                      </label>
                                    </td>
                                  </tr>
                                  <tr class="headerRow">
                                    <td colspan="30"><b>Keberlanjutan Aksi Perubahan</b></td>
                                  </tr>
                                  <tr>
                                    <td class="text-center">3</td>
                                    <td>
                                      Target Aksi Perubahan dalam jangka panjang tercapai
                                    </td>
                                    <td>
                                      <label for="optionRowM1" class="radioGroup">
                                        <input type="radio" id="optionRowM1" value="1" name="optionRowM" v-model="optionRowM" disabled>
                                        <span>1</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowM2" class="radioGroup">
                                        <input type="radio" id="optionRowM2" value="2" name="optionRowM" v-model="optionRowM" disabled>
                                        <span>2</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowM3" class="radioGroup">
                                        <input type="radio" id="optionRowM3" value="3" name="optionRowM" v-model="optionRowM" disabled>
                                        <span>3</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowM4" class="radioGroup">
                                        <input type="radio" id="optionRowM4" value="4" name="optionRowM" v-model="optionRowM" disabled>
                                        <span>4</span>
                                      </label>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="text-center">4</td>
                                    <td>
                                      Seluruh tujuan Aksi Perubahan dapat tercapai
                                    </td>
                                    <td>
                                      <label for="optionRowN1" class="radioGroup">
                                        <input type="radio" id="optionRowN1" value="1" name="optionRowN" v-model="optionRowN" disabled>
                                        <span>1</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowN2" class="radioGroup">
                                        <input type="radio" id="optionRowN2" value="2" name="optionRowN" v-model="optionRowN" disabled>
                                        <span>2</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowN3" class="radioGroup">
                                        <input type="radio" id="optionRowN3" value="3" name="optionRowN" v-model="optionRowN" disabled>
                                        <span>3</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowN4" class="radioGroup">
                                        <input type="radio" id="optionRowN4" value="4" name="optionRowN" v-model="optionRowN" disabled>
                                        <span>4</span>
                                      </label>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="text-center">5</td>
                                    <td>
                                      Manfaat Aksi Perubahan
                                    </td>
                                    <td>
                                      <label for="optionRowO1" class="radioGroup">
                                        <input type="radio" id="optionRowO1" value="1" name="optionRowO" v-model="optionRowO" disabled>
                                        <span>1</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowO2" class="radioGroup">
                                        <input type="radio" id="optionRowO2" value="2" name="optionRowO" v-model="optionRowO" disabled>
                                        <span>2</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowO3" class="radioGroup">
                                        <input type="radio" id="optionRowO3" value="3" name="optionRowO" v-model="optionRowO" disabled>
                                        <span>3</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowO4" class="radioGroup">
                                        <input type="radio" id="optionRowO4" value="4" name="optionRowO" v-model="optionRowO" disabled>
                                        <span>4</span>
                                      </label>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>

                              <p class="mt-5 mb-2 font-size-14">
                                Menurut Anda, bagaimana faktor berikut ini mendukung pelaksanaan aksi perubahan staf Anda ?
                              </p>

                              <table class="table table-stripped table-condensed mb-4">
                                <thead class="greyTheme">
                                  <tr>
                                    <th class="text-center align-middle" style="width:5%;">No</th>
                                    <th class="text-center align-middle">Pernyataan</th>
                                    <th class="text-center align-middle" colspan="4">Jawaban</th>
                                  </tr>
                                </thead>
                                <tbody class="greyTheme">
                                  <tr>
                                    <td class="text-center">6</td>
                                    <td>
                                      Terdapat dukungan dari Mentor
                                    </td>
                                    <td>
                                      <label for="optionRowP1" class="radioGroup">
                                        <input type="radio" id="optionRowP1" value="1" name="optionRowP" v-model="optionRowP" disabled>
                                        <span>1</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowP2" class="radioGroup">
                                        <input type="radio" id="optionRowP2" value="2" name="optionRowP" v-model="optionRowP" disabled>
                                        <span>2</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowP3" class="radioGroup">
                                        <input type="radio" id="optionRowP3" value="3" name="optionRowP" v-model="optionRowP" disabled>
                                        <span>3</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowP4" class="radioGroup">
                                        <input type="radio" id="optionRowP4" value="4" name="optionRowP" v-model="optionRowP" disabled>
                                        <span>4</span>
                                      </label>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="text-center">7</td>
                                    <td>
                                      Terdapat dukungan Pemangku Kepentingan
                                    </td>
                                    <td>
                                      <label for="optionRowQ1" class="radioGroup">
                                        <input type="radio" id="optionRowQ1" value="1" name="optionRowQ" v-model="optionRowQ" disabled>
                                        <span>1</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowQ2" class="radioGroup">
                                        <input type="radio" id="optionRowQ2" value="2" name="optionRowQ" v-model="optionRowQ" disabled>
                                        <span>2</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowQ3" class="radioGroup">
                                        <input type="radio" id="optionRowQ3" value="3" name="optionRowQ" v-model="optionRowQ" disabled>
                                        <span>3</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowQ4" class="radioGroup">
                                        <input type="radio" id="optionRowQ4" value="4" name="optionRowQ" v-model="optionRowQ" disabled>
                                        <span>4</span>
                                      </label>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="text-center">8</td>
                                    <td>
                                      Terdapat dukungan dari Anggota Tim
                                    </td>
                                    <td>
                                      <label for="optionRowR1" class="radioGroup">
                                        <input type="radio" id="optionRowR1" value="1" name="optionRowR" v-model="optionRowR" disabled>
                                        <span>1</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowR2" class="radioGroup">
                                        <input type="radio" id="optionRowR2" value="2" name="optionRowR" v-model="optionRowR" disabled>
                                        <span>2</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowR3" class="radioGroup">
                                        <input type="radio" id="optionRowR3" value="3" name="optionRowR" v-model="optionRowR" disabled>
                                        <span>3</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowR4" class="radioGroup">
                                        <input type="radio" id="optionRowR4" value="4" name="optionRowR" v-model="optionRowR" disabled>
                                        <span>4</span>
                                      </label>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="text-center">9</td>
                                    <td>
                                      Terdapat dukungan Sarana dan Prasarana
                                    </td>
                                    <td>
                                      <label for="optionRowS1" class="radioGroup">
                                        <input type="radio" id="optionRowS1" value="1" name="optionRowS" v-model="optionRowS" disabled>
                                        <span>1</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowS2" class="radioGroup">
                                        <input type="radio" id="optionRowS2" value="2" name="optionRowS" v-model="optionRowS" disabled>
                                        <span>2</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowS3" class="radioGroup">
                                        <input type="radio" id="optionRowS3" value="3" name="optionRowS" v-model="optionRowS" disabled>
                                        <span>3</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowS4" class="radioGroup">
                                        <input type="radio" id="optionRowS4" value="4" name="optionRowS" v-model="optionRowS" disabled>
                                        <span>4</span>
                                      </label>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td class="text-center">10</td>
                                    <td>
                                      Dijadikan kegiatan rutin dalam menunjang tugas dan fungsi
                                    </td>
                                    <td>
                                      <label for="optionRowT1" class="radioGroup">
                                        <input type="radio" id="optionRowT1" value="1" name="optionRowT" v-model="optionRowT" disabled>
                                        <span>1</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowT2" class="radioGroup">
                                        <input type="radio" id="optionRowT2" value="2" name="optionRowT" v-model="optionRowT" disabled>
                                        <span>2</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowT3" class="radioGroup">
                                        <input type="radio" id="optionRowT3" value="3" name="optionRowT" v-model="optionRowT" disabled>
                                        <span>3</span>
                                      </label>
                                    </td>
                                    <td>
                                      <label for="optionRowT4" class="radioGroup">
                                        <input type="radio" id="optionRowT4" value="4" name="optionRowT" v-model="optionRowT" disabled>
                                        <span>4</span>
                                      </label>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>

                              <table class="table table-borderless">
                                <tbody>
                                  <tr>
                                    <td class="text-center" style="width:5%;">11</td>
                                    <td>
                                      Sebutkan faktor pendukung pelaksanaan aksi perubahan yang lain, jika ada ?
                                    </td>
                                  </tr>
                                  <tr>
                                    <td></td>
                                    <td>
                                      <b-form-textarea id="myTextarea" v-model="myTextarea" placeholder="Tulis disini . . ." rows="3" max-rows="6" disabled></b-form-textarea>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </form>
                          </div>
                        </div>
                      </b-tab>
                    </b-tabs>
                  </div>
                </b-card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
